import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/noticiasCampañas';
import NoticiasCampañasList from './NoticiasCampañas';

const ms2p = (state) => {
    return {
        ...state.noticiasCampañas,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(NoticiasCampañasList);
